import styled from 'styled-components';
import { asRem } from 'utils';
import { colors } from 'View/Theme';
import { mediaQueries } from 'utils/Constants/Breakpoints';

import waveMobile from '../../img/bgr_waves_mobile.svg';
import waveDesktop from '../../img/bgr_waves.svg';
import starsBg from '../../img/stars.svg';

export default styled.div.attrs({
  className: 'sleep-page',
})`
  position: relative;
  background-color: ${colors.sleep.blue.c900} !important;
  background-image: url(${waveMobile});
  background-repeat: no-repeat;
  background-size: cover;
  min-height: calc(100vh - 230px);
  width: 100%;

  ${mediaQueries.md} {
    background-image: url(${waveDesktop});
  }

  .header-section {
    background-size: cover;
    background-position: center;
    width: 100%;
    background-image: url(${starsBg});
    z-index: 10;
    padding: ${asRem(100)} 0 0 0;

    ${mediaQueries.md} {
      padding: ${asRem(150)} 0 ${asRem(30)} 0;
    }

    ${mediaQueries.lg} {
      padding-bottom: 0;
    }

    .header-image {
      width: 90%;
      margin-bottom: -${asRem(10)};

      ${mediaQueries.md} {
        margin: -${asRem(10)} 0 ${asRem(50)} 0;
      }

      ${mediaQueries.lg} {
        margin-bottom: 0;
      }
    }

    .bottom-row-seals {
      margin-bottom: -${asRem(40)};
      align-items: center;

      ${mediaQueries.md} {
        margin-bottom: -${asRem(70)};
      }

      ${mediaQueries.lg} {
        margin-bottom: -${asRem(60)};
      }

      .col-left-seal {
        text-align: left;

        ${mediaQueries.md} {
          text-align: center;
        }

        ${mediaQueries.lg} {
          text-align: left;
        }
      }
    }

    .seal-customers {
      ${mediaQueries.lg} {
        width: ${asRem(200)};
      }
    }

    .seal-health {
      width: ${asRem(135)};

      ${mediaQueries.md} {
        width: ${asRem(140)};
      }

      ${mediaQueries.lg} {
        width: ${asRem(180)};
      }
    }

    .button-row {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      ${mediaQueries.md} {
        flex-direction: row;
      }
    }

    .cta-button,
    .link__store-btn-wrapper {
      margin-bottom: ${asRem(5)};

      ${mediaQueries.md} {
        margin: 0;
      }
    }
  }

  .video-section {
    position: relative;
    .mime-elements-headline-2 {
      margin-bottom: ${asRem(20)};
    }
      
    .freddy-image {
      position: absolute;
      right: -${asRem(20)};
      bottom: ${asRem(20)};
      width: ${asRem(100)};

      ${mediaQueries.md} {
        right: 0;
        bottom: 0;
        width: ${asRem(170)};
      }

      ${mediaQueries.lg} {
        width: ${asRem(250)};
        bottom: -${asRem(30)};
      }
    }
  }

  .cta-bottom {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center !important;

    .cta-button {
      margin-bottom: -${asRem(5)};
    }

    .mime-elements-headline-2 {
      text-align: center !important;
      margin-top: ${asRem(20)};

      ${mediaQueries.md} {
        text-align: left !important;
      }
    }

    .mime-elements-image {
      margin-top: ${asRem(20)};
    }
  }
`;
